import { SITE_NAME, SITE_URL } from './constants'

export function buildOrganization() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/icon.jpg`,
  }
}

export function buildWebSite() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
  }
}

export function buildArticle({ title, description, path, image, datePublished, dateModified }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url: `${SITE_URL}${normalizePath(path)}`,
    image: image || undefined,
    datePublished,
    dateModified: dateModified || datePublished,
    author: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
  }
}

export function buildPerson({ name, description, path, image }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name,
    description,
    url: `${SITE_URL}${normalizePath(path)}`,
    image: image || undefined,
  }
}

export function buildBreadcrumb(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path ? `${SITE_URL}${normalizePath(item.path)}` : undefined,
    })),
  }
}

function normalizePath(path) {
  if (!path) return '/'
  const clean = path.split('?')[0].replace(/\/+$/, '') || '/'
  return clean === '/' ? '/' : `${clean}/`
}
